import React from 'react';
import './Footer.css'; // Optional: for styling

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} ModByMuse. All rights reserved.</p>
                <p>Follow us on social media!</p>
                {/* Add social media links or icons here */}
            </div>
        </footer>
    );
};

export default Footer;